/** @module csi/widget/_svg/ShapeAlignVCenter */
define([
	"./_ShapeAlign",
	"./PluginFactory"
], function(_ShapeAlign,PluginFactory) {

	return PluginFactory.declare(_ShapeAlign, {
		/**
		 * @property {String} iconClass - CSS class to be applied.
		 */
		iconClass: "csiActionIcon svgIconAlignVCenter",

		/**
		 * @property {String} pluginName - Plugin name to be used for adding to toolbar.
		 */
		pluginName: "shapeAlignVCenter",

		/**
		 * @property {String} title - Title for the plugin icon.
		 */
		title: "CanvasShapeAlignVCenter",

		/**
		 * @property {String} shapeAlignOption - Shape align option: Top.
		 */
		shapeAlignOption: "vCenter"
	});
});
